import { Delete as DeleteIcon } from '@mui/icons-material';
import { List, ListItem, IconButton, type ListProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export type AttachmentsListProps =
    ListProps &
    {
        attachments: File[];
        onDeleteItem: (fileName: string) => void;
    };

const StyledListItem = styled(ListItem)`
    font-size: 12px;
    padding: 0;
`;

const formatSize = (size: number) => {
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let sizeUnit = 0;
    let n = size;

    while (n >= 1000) {
        n /= 1000;
        sizeUnit += 1;
    }

    return `${n.toFixed(2)} ${units[sizeUnit]}`;
};

export const AttachmentsList = (props: AttachmentsListProps) => {
    const { attachments, onDeleteItem, ...listProps } = props;
    const { t } = useTranslation('report_problem');

    if (attachments.length === 0) {
        return <></>;
    }

    return (
        <List {...listProps}>
            {attachments.map((attachment) => (
                <StyledListItem
                    key={attachment.name}
                >
                    <Typography sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        {attachment.name}
                    </Typography>

                    <Typography sx={{ ml: 'auto', whiteSpace: 'nowrap' }}>
                        {formatSize(attachment.size)}
                    </Typography>
                    <IconButton
                        aria-label={t('delete-attachment-label')}
                        color='error'
                        onClick={() => {
                            onDeleteItem(attachment.name);
                        }}
                        sx={{ padding: 0 }}
                    >
                        <DeleteIcon />
                    </IconButton>
                </StyledListItem>
            ))}
        </List>
    );
};
